import React, { ReactNode } from "react";
import * as styled from "./styled";

const AppContainer = ({ children }: { children: ReactNode }) => {
  return <styled.AppWrapper>{children}</styled.AppWrapper>;
};

export default AppContainer;
